var _regeneratorRuntime = require("/Users/jonathan/programming/rvx-lc/www/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createClass = require("/Users/jonathan/programming/rvx-lc/www/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/Users/jonathan/programming/rvx-lc/www/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var Node = /// value;
/// next;
function Node(value) {
  "use strict";

  _classCallCheck(this, Node);

  this.value = value; // TODO: Remove this when targeting Node.js 12.

  this.next = undefined;
};

var Queue = /*#__PURE__*/function () {
  "use strict";

  // TODO: Use private class fields when targeting Node.js 12.
  // #_head;
  // #_tail;
  // #_size;
  function Queue() {
    _classCallCheck(this, Queue);

    this.clear();
  }

  _createClass(Queue, [{
    key: "enqueue",
    value: function enqueue(value) {
      var node = new Node(value);

      if (this._head) {
        this._tail.next = node;
        this._tail = node;
      } else {
        this._head = node;
        this._tail = node;
      }

      this._size++;
    }
  }, {
    key: "dequeue",
    value: function dequeue() {
      var current = this._head;

      if (!current) {
        return;
      }

      this._head = this._head.next;
      this._size--;
      return current.value;
    }
  }, {
    key: "clear",
    value: function clear() {
      this._head = undefined;
      this._tail = undefined;
      this._size = 0;
    }
  }, {
    key: "size",
    get: function get() {
      return this._size;
    }
  }, {
    key: Symbol.iterator,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      var current;
      return _regeneratorRuntime.wrap(function value$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              current = this._head;

            case 1:
              if (!current) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return current.value;

            case 4:
              current = current.next;
              _context.next = 1;
              break;

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, value, this);
    })
  }]);

  return Queue;
}();

module.exports = Queue;